import CustomHeader from './component'

export default CustomHeader
